import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Global = () => {
    return <SharedDocumentsComponent permissionId="50" path="Global" />
}